var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1920,
    viewBox: "0 0 1080 1920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_1911)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4402_1911)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 793.5,
    cy: 471,
    r: 111,
    transform: "rotate(90 793.5 471)",
    fill: "#73AFD8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4402_1911)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 1678,
    r: 200,
    transform: "rotate(90 700 1678)",
    fill: "#99D5D5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4402_1911)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 802,
    r: 241,
    transform: "rotate(90 345 802)",
    fill: "#A1C9E5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4402_1911)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 1678,
    r: 200,
    transform: "rotate(90 200 1678)",
    fill: "#99D5D5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4402_1911",
    x: 282.5,
    y: -40,
    width: 1022,
    height: 1022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_4402_1911"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4402_1911",
    x: 100,
    y: 1078,
    width: 1200,
    height: 1200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_4402_1911"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4402_1911",
    x: -696,
    y: -239,
    width: 2082,
    height: 2082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 400,
    result: "effect1_foregroundBlur_4402_1911"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4402_1911",
    x: -400,
    y: 1078,
    width: 1200,
    height: 1200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_4402_1911"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(1080) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5ce68c73a764dee7d68e24d7f37df918.svg";
export { ForwardRef as ReactComponent };